import React, { useState } from 'react';
import { Link } from '@mui/joy';
import type { SxProps } from '@mui/joy/styles/types';
import { useTranslation } from 'react-i18next';
import { useNetworkScanGuideUrl } from '../../hooks/useNetworkScanGuideUrl';
import NetworkScanGuideModal from './NetworkScanGuideModal';

interface Props {
    sx?: SxProps;
}

/**
 * "Network scan guide" link (IBM-1039), shared by the document-scan modal, the
 * tab card and the IoT gate reason: a plain click opens the guide in a modal
 * on top of the current view; the href stays so modifier clicks and the
 * context menu still open the full page in a new tab.
 */
const NetworkScanGuideLink = ({ sx }: Props) => {
    const { t } = useTranslation();
    const pageUrl = useNetworkScanGuideUrl();
    const [open, setOpen] = useState(false);

    return (
        <>
            <Link
                href={pageUrl}
                target="_blank"
                rel="noopener noreferrer"
                level="body-sm"
                data-testid="network-scan-guide"
                sx={sx}
                onClick={(event) => {
                    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
                    event.preventDefault();
                    setOpen(true);
                }}
            >
                {t('Network scan guide')}
            </Link>
            {open && <NetworkScanGuideModal open onClose={() => setOpen(false)} />}
        </>
    );
};

export default NetworkScanGuideLink;
